/**
 * 大po
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/9      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import Lang from "@/components/Lang/Lang";
import PropTypes from "prop-types";
import config from "@config/config";
import {isEmpty,getRandomString,postHttpAction} from '@utils/utils';
import "./index.less";
import OrderStatus from "../OrderStatus/index";
import OrderProgress from "../../../components/OrderProgress";
import PriceComposition from "../../../components/PriceComposition";
import IconDirectPo from "@components/Icon/IconDirectPo/IconDirectPo";//直达图标
import { renderFileType } from "@components/UploadFile/UploadImage/file.util";
import {
    numberWithCommas,
    toFixedWithCommas,
} from "../../../../../utils/number-util";
import dayjs from "dayjs";
import Locale from "../../../../../utils/locale";
import {Tooltip,Button,message,Modal,Checkbox,Empty,Spin} from "antd";
import Cookie from "@utils/cookie";
import moment from "moment";
import PoDetailAction from "../../PoDetail.action";
let locale = Locale.current();
class SmallPo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stickerFileModalVisible: false,
            stickerFiles: [],
            selectedStickerFiles: [],
            isStickerFileLoading: false,
            selectAll: false,
            loading:true,
        };
    }
    loadingSticker(flag) {
        this.setState({
            loadingSticker: flag,
        });
    }
    rendOrderState(model={}){
        return model.orderType?
                <span>{model.statusBuyer?__getServerDictItem('sale_po_ddp_status_buyer_activity.'+model.statusBuyer):''}</span>
                :<span>{model.statusBuyer?__getServerDictItem('sale_po_ddp_status_buyer.'+model.statusBuyer):''}</span>
    }
    downExcel(poId){
        const currLocaleLang = Locale.current();
        const url =  config.servers[config.environment].exportApi +'/data/bpms/jreport/poexport/child-order-goods-print?template='+'DdpPoGoodsExportReport_'+currLocaleLang
            +'&token='+getRandomString(15)+'&pwd='+getRandomString(8)+'&langCode='+currLocaleLang+'&timestamps='+new Date().getTime()+'&lang='+currLocaleLang+'&isGetHttpConfig=true&isCheck=0&poId='+poId;
        window.open(url);
    }
    downStickerFile(model,stickerLayoutDownloadStatus){
        if(stickerLayoutDownloadStatus==2) {
            message.warning(Lang({id: "TieZhiWenJianShengChengZh", default: "贴纸文件生成中"}));
            if(!this.timer){
                const { model={}, } = this.props;
                this.timer =  setTimeout(()=>this.getDownSticker(model.id),2000);
            }
            return;
        }
        // 模拟获取贴纸文件列表 
        this.setState({
            stickerFileModalVisible: true,
            stickerFiles: model.stickerLayoutDownloadFileList||[],
        });
    }
    downSticker(poId){
        const postUrl = '/service/mg/sale/po/download-ddp-sticker-layout';
        const postData = {
            poId : poId,
        };
        this.loadingSticker(true);
        postHttpAction(postUrl,postData, (resData) => {
            //    stickerLayoutDownloadStatus  1:申请下载贴纸文件 2:贴纸文件生成中  3:贴纸文件可下载 4:贴纸文件下载失败
            const { success, valid, } = resData;
                if (success &&valid) {
                    this.setState({
                        currStickerDownloadStatus: 2,
                        stickerFileModalVisible:false
                    })
                    this.timer =  setTimeout(()=>this.getDownSticker(poId),1000);
                }else if(resData.message){
                    this.loadingSticker(false);
                    message.warning(resData.message)
                }
        })
    }
    // http://rap.essa.top:88/workspace/myWorkspace.action?projectId=84#8604
    getDownSticker(poId){
        const postUrl = '/mg/po/essa-one/po-sticker-layout-download';
        const postData = {
            id : poId,
        };
        this.loadingSticker(true);
        postHttpAction(postUrl,postData, (resData) => {
            //    stickerLayoutDownloadStatus  1:申请下载贴纸文件 2:贴纸文件生成中  3:贴纸文件可下载 4:贴纸文件下载失败
            const { success, valid, model} = resData;
            if (success &&valid&&model) {
                if(model.stickerLayoutDownloadStatus==2||model.stickerLayoutDownloadStatus==1){
                    this.timer =  setTimeout(()=>this.getDownSticker(poId),3000);
                }else if(model.stickerLayoutDownloadStatus==3){ // 更新下载文件
                    this.loadingSticker(false);
                    this.setState({
                        currStickerDownloadStatus: model.stickerLayoutDownloadStatus,
                        currModel:model
                    })
                }else{
                    this.loadingSticker(false);
                    this.setState({
                        currStickerDownloadStatus: model.stickerLayoutDownloadStatus,
                    })
                }
            }else if(resData.message){
                this.loadingSticker(false);
                message.warning(resData.message)
            }
        })
    }
    init(){
        const {fxUserId} = Cookie.getJSON("fmg.extra") || {};
        this.setState({
            fxUserId:fxUserId||"",
            loading:false,
        })
    }
    // 处理全选/取消全选
    handleSelectAll = (e) => {
        const {stickerFiles} = this.state;
        const selectAll = e.target.checked;
        const selectedStickerFiles = selectAll ? stickerFiles.map(file => file.id) : [];
        this.setState({
            selectAll,
            selectedStickerFiles
        });
    };
    // 处理单个文件选择
    handleSelectFile = (fileId) => {
        const {selectedStickerFiles, stickerFiles} = this.state;
        const newSelectedFiles = selectedStickerFiles.includes(fileId)
            ? selectedStickerFiles.filter(id => id !== fileId)
            : [...selectedStickerFiles, fileId];
        const selectAll = newSelectedFiles.length === stickerFiles.length;
        this.setState({
            selectedStickerFiles: newSelectedFiles,
            selectAll
        });
    };

    // 下载选中的贴纸文件
    handleDownloadSticker = () => {
        const {selectedStickerFiles,stickerFiles} = this.state;
        if (selectedStickerFiles.length === 0) {
            message.warning('请选择要下载的文件');
            return;
        }
        // message.info(`下载选中的 ${selectedStickerFiles.length} 个文件`);
        // 循环打开 下载选中的文件 url window.open 打开新窗口
        selectedStickerFiles.forEach(fileId => {
            const file = stickerFiles.find(f => f.id === fileId);
            if (file&&file.url) {
                window.open(file.url);
            }
        })
    };
    /**
     * 获取取消登记详情
     * */
    getCancelRegistration(code){
        if(isEmpty(code)){
            return false
        }else {
            const { model, } = this.props;
            this.loadingSticker(true);
            const postData = {
                id: model.poId
            }
            PoDetailAction.checkCancelRegister(postData).then(res=>this.handleCheckRes(res.data,code)).catch(err=>this.handleCheckRes(err,code));
        }
    }
    handleCheckRes(res,code){
        this.loadingSticker(false);
        const {success,valid,model={}} = res;
        if(success&&valid){
            this.props.history.push('/order/cancelRecord/AddNew?'+code)
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({id: 'NEWBORN_ZONE_006', default: '搜索不到此订单'}));
    }
    componentDidMount() {
        this.init();
    }
    componentWillUnmount(){
        clearTimeout(this.timer);
    }
    render() {
        const { model,itemList } = this.props;
        const {fxUserId,stickerFileModalVisible,currModel=null,
            loadingSticker=false,
            currStickerDownloadStatus=null,stickerFiles,selectedStickerFiles,selectAll,loading=false} = this.state;
        const newDownloadStatus = currStickerDownloadStatus || model.stickerLayoutDownloadStatus;
        const newStickerModel = currModel || model;
        return (<Spin spinning={loading}>
            <div className={`mb_20 flex-item-between`}>
                {/* 左 */}
                <div className="po-detail-card-wrap flex-1">
                    <div className="fw_700 font_18 black89 flex-item-between">
                        <div className={"lineH_27"}>
                                {model.noCertificateSplit==1?<Tooltip title={__getServerLanguage('ZhongGuoZhiFaDingDan')}><span className={"ml_4"}>
                                                <IconDirectPo size={18}></IconDirectPo>
                                            </span>
                                </Tooltip>:<i className={"iconfont icon-file-list-2-line1 mr_4 black89 fw_400 font_18"} />}
                                {model.code}

                        </div>
                        <div className="black45 font_12 lineH_27">
                            {dayjs(model.createTime).format(
                                "YYYY-MM-DD HH:mm:ss"
                            )}
                            <span className={"ml_6"}>{__getServerLanguage('XiaDan')}</span>
                        </div>
                    </div>
                    {/* 订单 状态 */}
                    <div className="status-tip-blue flex-item-between">
                        {/*装柜完成*/}
                        <div className="text-right only-status-tip-wrap">
                                {model.statusBuyer !== "-10" &&
                                model.statusBuyer !== "20" ? (<OrderProgress code={model.statusBuyer}
                                                   model={model}
                                                                             trigger={"hover"}
                                                                             placement={"bottomLeft"}
                                                   joinGroupIng={model.joinGroupIng}
                                                   transitCityName={model.transitCityName}
                                                   transitCountryName={model.transitCountryName}>
                                        {this.rendOrderState(model)} <i className="iconfont icon-icon-line-tip black33 fw_400 margin-left-5"></i>
                                    </OrderProgress>) : this.rendOrderState(model)}
                        </div>
                        {model.kizFlagVO&&model.kizFlagVO.kizStatus?<div className={`fw_700 mt_2${model.kizFlagVO.kizStatus=='10'?" color_FB7321":" color-green2"}`}>{model.kizFlagVO.kizStatusName}</div>:null}
                    </div>
                    {/*操作按钮组*/}
                    <div className={"mb_12"}>
                        <Button  className={"mr_8 ant-btn-primary-blue"} onClick={()=>this.downExcel(model.id)} >
                            {Lang({id: "PODanDaoChu", default: "PO单导出"})}
                        </Button>
                        {/*<ProdRequirementsDrawer className={"mr_8"} poId={model.id} refresh={()=>this.getPoHead()}>*/}
                        {/*<Button className={model.poItemRequireCount&&model.poItemRequireCount>0?"btn_pink":""}>{Lang({id: "ShengChanYaoQiu", default: "生产要求"})}*/}
                        {/*{model.poItemRequireCount&&model.poItemRequireCount>0?<span className={"ml_2"}>({model.poItemRequireCount})</span>:null}*/}
                        {/*</Button>*/}
                        {/*</ProdRequirementsDrawer>*/}
                        {/* 分销商 账号不能 取消登记 */}
                        {itemList.length>0&&isEmpty(fxUserId)&&<Button className={"mr_8 ant-btn-primary-blue"} onClick={()=>this.getCancelRegistration(model.code)}>{Lang({id: "QuXiaoDengJi", default: "取消登记"})}</Button>}
                        {/* tickerLayoutDownloadStatus  1:申请下载贴纸文件 2:贴纸文件生成中  3:贴纸文件可下载  4:贴纸文件下载失败 */}
                        {(!newDownloadStatus||newDownloadStatus==1||newDownloadStatus==4)?<Button className={"mr_8 ant-btn-primary-blue"}
                                                                                                  loading={loadingSticker}
                                                                                                                                onClick={()=>this.downSticker(model.id)} >
                            {Lang(newDownloadStatus==4?{id: "TieZhiWenJianShengChengSh", default: "贴纸文件生成失败"}:{id: "ShenQingXiaZaiTieZhiWenJi", default: "申请下载贴纸文件"})}
                        </Button>:<Button className={"mr_8 ant-btn-primary-blue"}
                                          loading={loadingSticker}
                                          onClick={()=>this.downStickerFile(newStickerModel,newDownloadStatus)}>
                            {newDownloadStatus==3?Lang({id: "TieZhiWenJianKeXiaZai", default: "贴纸文件可下载"}):Lang({id: "TieZhiWenJianShengChengZh", default: "贴纸文件生成中"})}
                        </Button>}
                    </div>
                    {/* 收货信息 */}
                    <div className="address-info black89 font_14">
                        {/* 仓库 */}
                        <div className={"warehouse fw_700"}>
                            <i className="iconfont icon-building-line mr_8 font_22"></i>{model.transitCityName}
                        </div>
                        {/* 收货人 */}
                        {(model.city||model.country||model.consigneeAddress||model.consigneeName||model.consigneeMonde)?<div className={"address mt_12"}>
                            <div className={"cont"}>
                                <p className={"black45"}>{model.city}，{model.country}</p>
                                <p>{model.consigneeAddress}</p>
                                <p className={"fw_700"}>{model.consigneeName}</p>
                                <p className={"fw_700"}>+{model.telCode}<span className={"ml_4"}>{model.consigneeMonde}</span></p>
                            </div>
                        </div>:null}
                        <div className="mt_12 po-option-tip">
                            <div className="info">
                                {/*<p className="tip">{model.isSplitOrder==1?__getServerLanguage('DingDanYiChaiFenBenDingDanJinE'):__getServerLanguage('BenDingDanJinE')}</p>*/}
                                {
                                    model.flag?
                                        <div className="color-red">
                                            {__getServerLanguage('YuJiFaHuoShiJian')}
                                            <span className="ml_4">{model.arrivalPortDate?dayjs(model.arrivalPortDate).format("YYYY-MM-DD"):''}</span>
                                        </div>
                                        : <>
                                            {(model.originalArrivalPortDate&&dayjs(model.originalArrivalPortDate).format("YYYY-MM-DD")!=(moment(model.arrivalPortDate).format("YYYY-MM-DD")))?
                                                <div>
                                                    <p className="color-red fw_700">
                                                        {__getServerLanguage('XinYuJiDaoGangShiJian')}
                                                        <span className="ml_4">{model.arrivalPortDate?dayjs(model.arrivalPortDate).format("YYYY-MM-DD"):''}</span>
                                                    </p>
                                                    <p className="black45 mt_4">
                                                        {__getServerLanguage('YuanShiYuJiDaoGangShiJian')}
                                                        <span className="util-del ml_4">{model.originalArrivalPortDate?dayjs(model.originalArrivalPortDate).format("YYYY-MM-DD"):''}</span>
                                                    </p>
                                                </div>
                                                :<div className="black45">
                                                    {__getServerLanguage('YuJiDaoGangShiJian')}
                                                    <span  className="ml_4">{model.arrivalPortDate?dayjs(model.arrivalPortDate).format("YYYY-MM-DD"):''}</span>
                                                </div>}
                                        </>}
                            </div>
                        </div>
                    </div>
                    {/*<div className="base-info-title">*/}
                    {/*{__getServerLanguage("ShouHuoXinXi")}：*/}
                    {/*</div>*/}
                </div>

                {/* 右*/}
                <div className="po-detail-card-wrap total_digital ml_16 black89">
                    <div className="font_18 mb_8"><i className="ri-calculator-line font_20"></i><span className="fw_700 ml_4">{__getServerLanguage('ZongJi')}</span></div>
                    <p className="font_12 black66">
                        {/* 款 箱*/}
                        {__getServerLanguage('NKuanNXiang',model.itemCount,model.totalQuantity)}
                        <span className="ml_4">{__getServerLanguage('ZongTiJi')}</span>
                        <span className="ml_2">{toFixedWithCommas(model.totalVolume,3)||'-'} m³,</span>
                        <span className="ml_4">{__getServerLanguage('MaoJingZhong')}</span>
                        <span className="ml_2">{model.totalGrossWeight||'-'}/ {model.totalNetWeight||'-'}</span>
                    </p>

                    <div className="digital mt_12">
                        {/*<span>{numberWithCommas(toFixedWithCommas(model.totalPrice,2)||0)||'-'} {model.currencySymbol}</span>*/}
                        <PriceComposition model={model} noPopover={true} />
                    </div>

                    {/* 已退款并更新订单金额 */}
                    {
                        model.refundDescribeType?
                            <p className="color-red font_12">{__getServerLanguage(model.refundDescribeType)}</p>
                            :
                            null
                    }

                    {
                        (model.cancelRefundTotal&&!model.refundDescribeType)?
                            <p className="color-red">{__getServerLanguage('YiTuiKuan')} {numberWithCommas(toFixedWithCommas(model.cancelRefundTotal,2))} {model.currencySymbol}</p>
                            :
                            null
                    }
                    {/* 以上为本订单信息 */}
                    <p className={"black33 font_12"}>* {__getServerLanguage('YiShangWeiBenDingDanXinXi')} </p>
                </div>
            </div>

        {model.id ? <OrderStatus poId={model.id}></OrderStatus> : null}
        
        {/* 贴纸文件弹窗 */}
        <Modal title={<div className={"flex-item-between"}>
                {Lang({id:'TieZhiWenJian', default: '贴纸文件'})}
                <div>
                    <Button key="regenerate" onClick={()=>this.downSticker(model.id)}>
                        {Lang({id:'ZhongXinShengCheng', default: '重新生成'})}
                    </Button>
                    <Button key="download" className={"ml_4"} type="primary"  style={{ background:"#F1554C"}}
                            onClick={this.handleDownloadSticker}>
                        {Lang({id:'XiaZai', default: '下载'})}
                    </Button>
                </div>
            </div>}
            open={stickerFileModalVisible}
               destroyOnHidden={true}
            onCancel={() => this.setState({ stickerFileModalVisible: false })}
            footer={null}
            closable={false}
            width={600}>
            <Spin spinning={loading}>
                <div className="mb_16">
                    <Checkbox
                        checked={selectAll}
                        onChange={this.handleSelectAll}>
                        <span className={"black89 fw_700 font_16"}>{Lang({id:'QuanXuan', default: '全选'})}</span>
                    </Checkbox>
                </div>
            {stickerFiles&&stickerFiles.length>0?<div className={"popFilesDownSticker black89 fw_700 font_16"}>
                    {stickerFiles.map(file=><div className={"flex-item"}>
                        <Checkbox
                            checked={selectedStickerFiles.includes(file.id)}
                            onChange={() => this.handleSelectFile(file.id)}
                        />
                        <span className="ml_4 mr_4">
                            {file.realNameWithExtend?renderFileType(file.realNameWithExtend):null}
                        </span>
                        {file.realNameWithExtend}
                    </div>)}
                </div>: <Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})} className="mt_40 mb_40"></Empty>}
            </Spin>
        </Modal>
        </Spin>);
    }
}

SmallPo.defaultProps = {
    model: {},
    callBack: function () {},
};

SmallPo.propTypes = {
    model: PropTypes.object,
    callBack: PropTypes.func,
};
export default SmallPo;
